import mitt from "mitt";

export const emitter = mitt();

export enum MittType {
  autofocus = "autofocus",
  resize = "resize",
  tabChange = "tabChange",
  asyncValidationEnds = "asyncValidationEnds",
}
